import moment from 'moment';

function setDisplayTime (durationObject) {
  const timeElements = document.querySelectorAll('.coming-soon-countdown__timer');
  timeElements.forEach(element => {
    let parentContainer = element.parentElement.parentElement.parentElement.parentElement;
    if (parentContainer.classList.contains('bottom-info')) {
      element.classList.remove('coming-soon-countdown__timer--white');
    }
    element.innerHTML = '';
    let { months, days, hours, minutes, seconds } = durationObject;

    if (-parseInt(months) >= 1) {
      element.innerHTML += `<div class="coming-soon-countdown__timer-column"><span class="coming-soon-countdown__timer-value">${-parseInt(months)}</span><span class="coming-soon-countdown__timer-label">Months</span></div>`
    }
    element.innerHTML += `<div class="coming-soon-countdown__timer-column"><span class="coming-soon-countdown__timer-value">${-parseInt(days)}</span><span class="coming-soon-countdown__timer-label">Days</span></div>`
    element.innerHTML += `<div class="coming-soon-countdown__timer-column"><span class="coming-soon-countdown__timer-value">${-parseInt(hours)}</span><span class="coming-soon-countdown__timer-label">Hours</span></div>`
    element.innerHTML += `<div class="coming-soon-countdown__timer-column"><span class="coming-soon-countdown__timer-value">${-parseInt(minutes)}</span><span class="coming-soon-countdown__timer-label">minutes</span></div>`
  });
}

function getTimeFrameDifference (date) {
  const countDownDate = moment(date);
  const today = moment();
  const days = today.diff(countDownDate, 'dd:hh:mm:s');
  const duration = moment.duration(days)._data;
  setDisplayTime(duration);
}

function ComingSoonCountDown (element) {
  const { date } = element.dataset;
  getTimeFrameDifference(date);
  setInterval(() => {
    getTimeFrameDifference(date);
  }, 60000);
}

export default ComingSoonCountDown;